import { render, staticRenderFns } from "./NotificationTemplateViewer.vue?vue&type=template&id=2511f22d&scoped=true&"
import script from "./NotificationTemplateViewer.vue?vue&type=script&lang=js&"
export * from "./NotificationTemplateViewer.vue?vue&type=script&lang=js&"
import style0 from "./NotificationTemplateViewer.vue?vue&type=style&index=0&id=2511f22d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2511f22d",
  null
  
)

export default component.exports